// extracted by mini-css-extract-plugin
module.exports = {"themeGraphic":"speakers_themeGraphic__eY3GG","avatar":"speakers_avatar__jt8lF"};